var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn btn-primary btn-white",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.handlePrint.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }